import Vue from 'vue'
import i18n from '@/plugins/i18n'
import Message from '@/components/Message.vue'

const MessageClass = Vue.extend(Message)

let container: HTMLElement
let instance: Vue | undefined

export default {

  setContainer (newContainer: HTMLElement) {
    container = newContainer
  },

  error (title: string, message: string) {
    if (!container || instance) {
      // tslint:disable-next-line
      console.error(title, message)
      return
    }

    instance = new MessageClass({
      propsData: {
        type: 'error',
        title,
        message
      },
      i18n
    })
    instance.$on('closed', () => {
      if (instance) {
        instance.$destroy()
        container.removeChild(instance.$el)
        instance = undefined
      }
    })
    instance.$mount()
    container.appendChild(instance.$el)
  }

}
